import { render } from "./AdminContacts.vue?vue&type=template&id=6f90ed71&scoped=true"
import script from "./AdminContacts.vue?vue&type=script&lang=js"
export * from "./AdminContacts.vue?vue&type=script&lang=js"

import "./AdminContacts.vue?vue&type=style&index=0&id=6f90ed71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f90ed71"]])

export default __exports__